import * as Endpoints from '../Entities/EndPoints'
import Axios from '../Axios'

const API_FORMDATA = Axios.getInstanceForFormData
const API = Axios.getInstance

export const createSurveyTemplate = (data, loginId) => {
    const params = { loginId }

    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_SURVEY_DATA, data, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getSurveyTemplate = (vertexId, templateId) => {
    let URL = Endpoints.GET_SURVEY_DATA
    URL = URL.replace('{vertexId}', vertexId)
    URL = URL.replace('{templateId}', templateId)

    return API(Endpoints.API_ENDPOINT)
        .get(URL)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const updateSurveyTemplate = (data, loginId, organizationId) => {
    const params = { loginId, organizationId }

    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.UPDATE_SURVEY_DATA, data, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const createBoardComposition = (data, loginId) => {
    const params = { loginId }

    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_BOARD_COMPOSITION, data, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const createOrganizationChart = (data, loginId, orgId) => {
    const params = { loginId, orgId }

    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_ORG_CHART, data, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const editOrganizationChartNode = (data) => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.EDIT_ORG_CHART_NODE, data)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const createOrgRegulation = (data, loginId, orgId) => {
    const params = { loginId, orgId }

    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_ORG_REGULATION, data, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getBoardComposition = (orgId) => {
    const params = { orgId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_BOARD_COMPOSITION, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getOrganizationChart = (orgId, loginId) => {
    const params = { orgId, loginId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ORG_CHART, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getUserDetailsById = (userId) => {
    const params = { userId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_USER_DETAILS_BY_ID, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getOrgRegulation = (orgId, loginId, typeId) => {
    const params = { orgId, loginId, typeId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ORG_REGULATION, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getOrgType = (organizationId) => {
    const params = { organizationId }
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_ORG_TYPE, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const createCompanyProfile = (data, loginId) => {
    const params = { loginId }

    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_COMPANY_PROFILE, data, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getCompanyProfile = (orgId) => {
    const params = { orgId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_COMPANY_PROFILE, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getCountry = (data) => {
    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_COUNTRY, data)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getState = (id) => {
    const params = { id }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_STATE, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getCity = (id) => {
    const params = { id }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_CITY, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}
